import React from "react";
import RNButton from "@components/Button";

const Button = ({
  formItem,
  onSubmit,
  disabled,
  buttonWidth = "100%",
  buttonStyles = {},
  // borderRadius = 0,
}) => {
  return (
    <RNButton
      buttonWidth={"100%"}
      disabled={disabled}
      btnText={formItem && `${formItem.label} `}
      buttonFontType="head2"
      height={56}
      textColor={disabled ? "rgba(0,0,0,0.36)" : "#FFFFFF"}
      onPress={onSubmit}
      borderRadius={8}
      textStyle={{ fontFamily: "NotoSansDevanagari-Bold", marginTop: 4 }}
      containerStyle={{
        alignSelf: "center",
        marginTop: 20,
        width: "100%",
      }}
    />
  );
};

export default Button;
